const AddressFormatter = {
  methods: {
    formatAddress(person, withAddress = true, withSalutation = true) {
      if (person.anrede === "Firma") {
        return this.formatCompanyAddress(person, withAddress);
      }

      return this.formatPersonalAddress(person, withAddress, withSalutation);
    },
    formatCompanyAddress(person, withAddress = true) {
      const baseAddress = this.formatBaseAddress(person);
      let namesPart = "";

      if (person.firma) {
        namesPart = `${person.anrede}\n${person.firma}`;
        return withAddress ? `${namesPart}\n${baseAddress}` : `${namesPart}`;
      }

      namesPart = this.formatPersonName(person, false);

      return withAddress
        ? `${person.anrede} ${namesPart}\n${baseAddress}`
        : `${person.anrede} ${namesPart}`;
    },
    formatPersonalAddress(person, withAddress = true, withSalutation = true) {
      const baseAddress = this.formatBaseAddress(person);
      const hasCoupleInfo =
        person.anrede_2 && person.vorname_2 && person.nachname_2;

      const namesPart = hasCoupleInfo
        ? this.formatCoupleNames(person, withSalutation)
        : this.formatPersonName(person, withSalutation);

      return withAddress ? `${namesPart}\n${baseAddress}` : namesPart;
    },
    formatPersonName(person, withSalutation = true) {
      const anredePrefix = person.anrede ? person.anrede + "\n" : "";
      const titlePrefix = person.titel ? person.titel + " " : "";

      return withSalutation
        ? `${anredePrefix}${titlePrefix}${person.vorname} ${person.nachname}`
        : `${person.vorname} ${person.nachname}`;
    },
    formatCoupleNames(person, withSalutation = true) {
      const titlePrefix = person.titel ? person.titel + " " : "";
      const coupleTitlePrefix = person.titel_2 ? person.titel_2 + " " : "";

      return withSalutation
        ? `${person.anrede} ${titlePrefix}${person.vorname} ${person.nachname} & ${person.anrede_2} ${coupleTitlePrefix}${person.vorname_2} ${person.nachname_2}`
        : `${person.vorname} ${person.nachname} & ${person.vorname_2} ${person.nachname_2}`;
    },
    formatBaseAddress(person) {
      return `${person.strasse} ${
        person.hausnr && person.hausnr !== "null" ? person.hausnr : ""
      }\n${person.plz} ${person.ort}`;
    },
    generateSalutationLine(person) {
      if (person.anrede === "Firma") {
        return "Sehr geehrte Damen und Herren";
      }

      const hasPartner = person.anrede_2 && person.nachname_2;
      const generateSingleSalutation = (anrede = null, nachname = null) => {
        if (!anrede || !nachname) {
          return "Sehr geehrte Damen und Herren";
        }

        const mappings = {
          herr: "Sehr geehrter Herr " + nachname,
          frau: "Sehr geehrte Frau " + nachname,
          familie: "Sehr geehrte Familie " + nachname,
        };

        return (
          mappings[anrede.toLowerCase()] ??
          `Sehr geehrte/r ${anrede} ${nachname}`
        );
      };

      if (hasPartner) {
        const salutation1 = generateSingleSalutation(
          person.anrede,
          person.nachname
        );
        const salutation2 = generateSingleSalutation(
          person.anrede_2,
          person.nachname_2
        );

        return `${salutation1}, ${this.lcFirst(salutation2)}`;
      }

      return generateSingleSalutation(person.anrede, person.nachname);
    },
    lcFirst(str) {
      return str.charAt(0).toLowerCase() + str.slice(1);
    },
  },
};
export default AddressFormatter;
